export default {
  SSR_GQL_ENDPOINT: process.env.SSR_GQL_ENDPOINT || 'http://localhost:5000/api',
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja9.kuikr.com',
  STATIC_FILE_PATH: process.env.STATIC_FILE_PATH || 'clsfd',
  APP_PORT: process.env.PORT || '3000',
  DOMAIN: process.env.DOMAIN || 'https://www.quikr.com',
  GA4_ID: process.env.GA4_ID || 'G-WMY8XWRKEV'
};
